// extracted by mini-css-extract-plugin
module.exports = {"site_settings_wrapper":"SiteSettings_site_settings_wrapper__1rghR","input_field_label_wrapper":"SiteSettings_input_field_label_wrapper__1Ini4"};